import React from 'react'
import { FormComponent } from '../../../components/form/DynamicForm'
import { Form, Validators } from '../../../components/form/DynamicFormTs'
import { withRouter } from "react-router-dom";

class Giro extends FormComponent {

  componentDidMount() {
    this.FormConfig(
      { defaultUrl: 'giro/one', saveUrl: 'giro/save', backUrl: '/Catalogo/Giros' },
      new Form([
        Form.Field('text', 'giro', 'Clave', '', [Validators.required], 4),
        Form.Field('text', 'giro_nombre', 'Giro', '', [Validators.required], 8),
      ], ['Guardar'], 'Giro de negocio'), this.formData
    )
    if (this.props.match.params.id)
      this.LoadPreds()
  }

  render() {
    return (
      <div>
        <this.FormRender />
      </div>
    )
  }
}

export default withRouter(Giro)
